export default "__VITE_ASSET__DzMAJ4s___"